import xProductPartNumbersStyles from "@flip/App/SharedStyle/ProductPartNumbersStyles";
import ProductBrand, { ProductBrandStyles } from "@flip/Overrides/Components/ProductBrand";
import { parseBoolean } from "@flip/XDL/Utilities";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsManufacturerStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    brand?: ProductBrandStyles;
}

export const productDetailsManufacturerStyles: ProductDetailsManufacturerStyles = {
    labelText: xProductPartNumbersStyles.large.label,
    valueText: xProductPartNumbersStyles.large.value,
    brand: {
        nameLink: {
            css: css`
                ${TypographyStyle} {
                    font-size: 14px;
                    line-height: 22px;
                    margin-bottom: 0;
                }
            `,
        },
    },
};

const styles = productDetailsManufacturerStyles;

const ProductDetailsManufacturer: React.FC<Props> = ({ product }) => {
    if (!product.brand) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p">
            <Typography {...styles.labelText}>{translate("MFR")}</Typography>
            {/* XNG-Changes: FLIP-507 */}
            <ProductBrand
                brand={product.brand}
                showLogo={false}
                isAuthorized={parseBoolean(product.properties.isAuthorizedBrand)}
                extendedStyles={styles.brand}
            />
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsManufacturer),
    definition: {
        displayName: "Manufacturer",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
